// CORE
import { Component, OnInit, OnDestroy, Injector } from '@angular/core';
import { ModalSize } from "@signal/component-library/efx-modal";
import { Router } from '@angular/router';
import { Validators, FormControl, FormGroup, FormBuilder } from '@angular/forms';
import { Subject, Observable } from 'rxjs';

// SERVICE
import { BuscadorService } from './../../../services/shared/buscador/buscador.service';
import { FuenteDinamicaService } from 'src/app/services/shared/fuente-dinamica/fuente-dinamica.service';
import { GenerateTokenService } from 'integrationpingid-lib';
import { HandleProfileService } from './../../../services/shared/handle-profile/handle-profile.service';
import { LocalStorageService } from 'src/app/services/shared/local-storage/local-storage.service';
import { MenuService } from 'src/app/services/shared/menu/menu.service';
import { NotificationService } from 'src/app/services/shared/notification/notification.service';
import { SharedService } from 'src/app/services/shared/shared.service';

// Entitys & Interfaces
import { Col } from './data-table/Col';
import { Country } from 'src/app/entities/shared/Country';
import { Documento } from 'src/app/entities/shared/Documento';
import { IAbmBuscador } from './../../../interfaces/pages/abm/abm-buscador.interface';
import { Icountry } from 'src/app/entities/shared/Country';
import { Menu } from 'src/app/entities/shared/Menu';
import { Persona } from 'src/app/entities/shared/Persona';
import { ResultsTable } from './data-table/ResultsTable';
import { SearchCountry } from './data-table/SearchCountry';

import { environment } from 'src/environments/environment';
import COUNTRIES from "src/assets/data/shared/COUNTRIES.json";

import { catchError, forkJoin, of, retry, throwError, takeUntil, map, shareReplay } from 'rxjs';
import { SearchGlobalService } from 'src/app/services/shared/search-global.service';
import { GfdService } from 'src/app/services/shared/gfd/gfd.service';

@Component({
  selector: 'app-home-searcher',
  templateUrl: './home-searcher.component.html',
  styleUrls: ['./home-searcher.component.scss'],
  standalone: false
})
export class HomeSearcherComponent implements OnInit, OnDestroy {

  countries: Icountry[] = COUNTRIES;
  private destroy$ = new Subject<void>();
  private _configData$: Observable<any>;

  // Var zone
  componentName = "HomeSearcherComponent";
  configSearchData: IAbmBuscador[] = [];

  private get configData$(): Observable<any> {
    if (!this._configData$) {
      const typeService = this.localStorageService.getIsVip ? 'VIP' : 'DM';
      const country = this.regionSeleccionada.getCode().toLocaleUpperCase();
      const method = 'DEFAULT';
      this._configData$ = this.searchGlobalService.getSearchGlobal(country, typeService, method).pipe(
        retry(3),
        shareReplay(1),
        catchError(err => {
          console.error('getConfigData: Falló después de los reintentos:', err);
          return throwError(() => new Error('No se pudo cargar la configuración del buscador después de varios intentos.'));
        })
      );
    }
    return this._configData$;
  }
  resultInput: string;
  resultsTable: ResultsTable;
  searchPersonForm: FormGroup;
  showResultTable: boolean = false;

  // Modal de configuraciones
  showConfigModal: boolean = false;
  availableConfigs: any[] = [];
  loadingConfigs: boolean = false;
  currentMenuForNewEntity: Menu | null = null;
  statusTokenUser: boolean = false;
  showSinResultado: boolean = false;
  altaEntidadesDocumentVar: string;
  allTablet = [];
  showInput: string = '';

  // Modal Variables
  bodyModal: string;
  modalSize = ModalSize;
  showimgModal: boolean;
  showModal: boolean = false;
  tituloModal: string;
  options: Array<any> = [{
    key: "",
    name: "Seleccione una opción",
    disabled: false
  }];
  typeAllProfile: boolean = false;

  // Providers
  private buscadorService: BuscadorService;
  private formBuilder: FormBuilder;
  private fuenteDinamicaService: FuenteDinamicaService;
  private handleProfileService: HandleProfileService;
  private menuService: MenuService;
  private router: Router;
  private sharedService: SharedService;
  public serviceToken: GenerateTokenService;
  private gfdService: GfdService;

  get regionSeleccionada(): Country {
    return this.localStorageService.getRegionSeleccionada;
  }

  get profileSelected(): IAbmBuscador | null {
    const valueSelect = this.searchPersonForm?.get("selectIdSubDomain")?.value;
    if (!this.configSearchData || this.configSearchData.length === 0 || valueSelect === null || valueSelect === undefined) {
      return null;
    }
    return this.configSearchData.find(config => config.id === valueSelect) || null;
  }

  get hasAdvancedConfig(): boolean {
    return this.profileSelected?.configAvanced?.some(f => f.name && f.name.trim() !== '') ?? false;
  }

  get advancedFieldsSorted() {
    if (!this.hasAdvancedConfig) return [];
    return this.profileSelected.configAvanced
      .filter(f => f.visible !== false)
      .sort((a, b) => a.order - b.order);
  }

  get identifiersFieldsSorted() {
    if (!this.profileSelected?.identifiers) return [];
    return this.profileSelected.identifiers
      .filter(f => f.visible === true && f.typeValue === 'input')
      .sort((a, b) => parseInt(a.order) - parseInt(b.order));
  }
  constructor(
    injector: Injector,
    private localStorageService: LocalStorageService,
    private notificationService: NotificationService,
    private searchGlobalService: SearchGlobalService
  ) {
    this.buscadorService = injector.get<BuscadorService>(BuscadorService);
    this.formBuilder = injector.get<FormBuilder>(FormBuilder);
    this.fuenteDinamicaService = injector.get<FuenteDinamicaService>(FuenteDinamicaService);
    this.handleProfileService = injector.get<HandleProfileService>(HandleProfileService);
    this.menuService = injector.get<MenuService>(MenuService);
    this.router = injector.get<Router>(Router);
    this.serviceToken = injector.get<GenerateTokenService>(GenerateTokenService);
    this.sharedService = injector.get<SharedService>(SharedService);
    this.gfdService = injector.get<GfdService>(GfdService);
    this.createForm();
  }

  ngOnInit() {
    this.resultInput = null;
    this.localStorageService.esAltaEntidades = false;
    this.localStorageService.esInternoRDS = false;

    this.onInitSearch();
  }

  onInitSearch() {
    const currentCountry: string = this.regionSeleccionada.getCode();
    this.statusTokenUser = this.serviceToken.statusTokenUser();

    if (this.statusTokenUser) {
      if (currentCountry === null) {
        this.router.navigateByUrl('/');
      } else {
        this.getConfigDataTwo();
      }
    } else {
      if (!(environment.USE_LOGIN.toString().toLowerCase() === "true")) {
        if (currentCountry === null) {
          this.router.navigateByUrl('/');
        } else {
          this.getConfigDataTwo();
          this.statusTokenUser = true;
        }
      }
    }
  }

  getConfigDataTwo() {

    this.configData$.pipe(
      takeUntil(this.destroy$)
    ).subscribe({
      next: (configData: any) => {
        if (!configData || !Array.isArray(configData.items) || configData.items.length === 0) {
          this.showModalTableNoConfig();
          return;
        }
        const keyConfig: string = Object.keys(configData)[0];
        console.log("keyConfig -->", keyConfig);
        console.log("configData[keyConfig] -->", configData);

        this.configSearchData = configData.items
          ?.sort((a, b) => (parseInt(a?.order) > parseInt(b?.order) ? 1 : -1)) || [];

        if (this.configSearchData.length > 0) {
          const firstId = this.configSearchData[0]?.id;
          this.searchPersonForm.get('selectIdSubDomain')?.setValue(firstId);

          let configCountry = this.regionSeleccionada;
          configCountry.url_find = this.configSearchData;
          console.log("firstId -->", firstId);
          this.localStorageService.setRegionSeleccionada = configCountry;
          const options = this.setOption(this.configSearchData);
          this.options = options;
          if (!this.localStorageService.getIsVip) {
            this.options.push({
              "key": "0",
              "name": "Todas las opciones",
              "disabled": false
            })
          }
          this.resetMensajes(firstId);
        } else {
          this.showModalTableNoConfig();
        }
        this.setMenuStorage();
      },
      error: err => {
        console.error('Error en carga de configTabla:', err);
      }
    });
  }

  getConfigData() {
    const typeService = this.localStorageService.getIsVip ? 'VIP' : 'DM';
    const country = this.regionSeleccionada.getCode().toLocaleUpperCase();
    const method = 'DEFAULT';

    this.searchGlobalService.getSearchGlobal(country, typeService, method).pipe(
      retry(3), // total 3 intentos
      takeUntil(this.destroy$),
      catchError(err => {
        console.error('getConfigData: Falló después de los reintentos:', err);
        return throwError(() => new Error('No se pudo cargar la configuración del buscador después de varios intentos.'));
      })
    ).subscribe({
      next: (configData: any) => {
        if (!configData || !Array.isArray(configData.items) || configData.items.length === 0) {
          this.showModalTableNoConfig();
          return;
        }
        const keyConfig: string = Object.keys(configData)[0];
        console.log("keyConfig -->", keyConfig);
        console.log("configData[keyConfig] -->", configData);
        this.configSearchData = configData.items
          ?.sort((a, b) => (parseInt(a?.order) > parseInt(b?.order) ? 1 : -1)) || [];
        const firstId = this.configSearchData[0]?.id;
        this.searchPersonForm.get('selectIdSubDomain')?.setValue(firstId);

        if (this.configSearchData.length > 0) {
          let configCountry = this.regionSeleccionada;
          configCountry.url_find = this.configSearchData;
          this.localStorageService.setRegionSeleccionada = configCountry;
          const options = this.setOption(this.configSearchData);
          this.options = options;
          if (!this.localStorageService.getIsVip) {
            this.options.push({
              "key": "0",
              "name": "Todas las opciones",
              "disabled": false
            })
          }
        }
        this.setMenuStorage();
        this.resetMensajes(firstId);
      },
      error: err => {
        console.error('Error en carga de configTabla:', err);
      }
    });
  }

  goToMenuApps() {
    this.localStorageService.setMenuApp = null;
    this.router.navigateByUrl(
      this.localStorageService.getIsVip
        ? environment.URL_RETURN_APP_VIP
        : this.localStorageService.getIsExternoRDS
          ? environment.URL_RETURN_APP_RDS
          : environment.URL_RETURN_APP
    );
  }

  closeModal() {
    this.showModal = false;
    if (!this.localStorageService.getIsVip) this.goToMenuApps();
  }

  createForm(): void {
    this.searchPersonForm = this.formBuilder.group({
      idNumber: ['', Validators.required],
      selectIdSubDomain: new FormControl(""),
      name: [''],
      secondName: [''],
      surname: [''],
      secondSurname: [''],
      companyName: ['']
    });
  }

  private getPreservedSearchValue(previousValues: Record<string, any> = {}, fieldName?: string): any {
    const fixedNames = ['idNumber', 'selectIdSubDomain', 'name', 'secondName', 'surname', 'secondSurname', 'companyName'];
    const candidateKeys = [
      ...(fieldName ? [fieldName] : []),
      ...Object.keys(this.searchPersonForm.controls)
    ].filter((key, index, arr) => arr.indexOf(key) === index);

    for (const key of candidateKeys) {
      if (fixedNames.includes(key)) {
        continue;
      }

      const value = previousValues[key] ?? this.searchPersonForm.get(key)?.value;
      if (value !== null && value !== undefined && value !== '') {
        return value;
      }
    }

    if (this.resultInput !== null && this.resultInput !== undefined && this.resultInput !== '') {
      return this.resultInput;
    }

    const legacyValue = this.searchPersonForm.get('idNumber')?.value;
    if (legacyValue !== null && legacyValue !== undefined && legacyValue !== '') {
      return legacyValue;
    }

    return '';
  }

  resetMensajes(event?) {
    const country = this.regionSeleccionada.getCode();
    const selectedId = typeof event === 'string' || typeof event === 'number'
      ? String(event)
      : event?.value ?? event?.target?.value;

    if (selectedId !== undefined && selectedId !== null) {
      this.searchPersonForm.get('selectIdSubDomain')?.setValue(String(selectedId), { emitEvent: false });
    }

    const idCtrl = this.searchPersonForm.get('idNumber');
    const previousValues = Object.keys(this.searchPersonForm.controls).reduce((acc, key) => {
      const control = this.searchPersonForm.get(key);
      if (control && !['idNumber', 'selectIdSubDomain', 'name', 'secondName', 'surname', 'secondSurname', 'companyName'].includes(key) && control.value !== null && control.value !== '') {
        acc[key] = control.value;
      }
      return acc;
    }, {} as Record<string, any>);

    this.showResultTable = false;
    this.showSinResultado = false;
    this.clearDynamicControls();

    const selectedProfile = this.profileSelected;
    if (selectedProfile) {
      // Persistir el buscador activo para flujos posteriores de GFD/keying.
      this.localStorageService.setBuscadorSelect = selectedProfile;
    }

    const nameCtrl = this.searchPersonForm.get('name');
    const surnameCtrl = this.searchPersonForm.get('surname');

    const companyCtrl = this.searchPersonForm.get('companyName');
    const personControls = [nameCtrl, surnameCtrl];

    const legacyControls = ['name', 'surname', 'secondName', 'secondSurname', 'companyName'];

    if (this.hasAdvancedConfig || (this.profileSelected?.identifiers?.length > 0)) {
      this.showInput = 'advanced';

      idCtrl?.clearValidators();
      idCtrl?.updateValueAndValidity();

      if (this.hasAdvancedConfig) {
        this.profileSelected.configAvanced.forEach(field => {
          const fieldNameUpper = field.name.toUpperCase();
          const previousValue = previousValues[fieldNameUpper] ?? this.getPreservedSearchValue(previousValues, fieldNameUpper);
          if (!this.searchPersonForm.contains(fieldNameUpper)) {
            const isVisible = field.visible !== false;
            const validators = (isVisible && field.required) ? [Validators.required] : [];
            this.searchPersonForm.addControl(fieldNameUpper, new FormControl(previousValue ?? '', validators));
          }
        });
      }

      this.identifiersFieldsSorted.forEach(field => {
        const fieldNameUpper = field.name.toUpperCase();
        const previousValue = previousValues[fieldNameUpper] ?? this.getPreservedSearchValue(previousValues, fieldNameUpper) ?? field.value ?? this.resultInput ?? '';

        if (!this.searchPersonForm.contains(fieldNameUpper)) {
          const validators = field.required ? [Validators.required] : [];
          this.searchPersonForm.addControl(fieldNameUpper, new FormControl(previousValue, validators));
        }
      });
    } else if (country === 'uy' && (event === '9' || event === '10')) {

      this.showInput = event === '9' ? 'consumer' : 'commercial';
      idCtrl?.clearValidators();
      idCtrl?.updateValueAndValidity();

      if (this.showInput === 'consumer') {
        personControls.forEach(ctrl => {
          ctrl?.setValidators([Validators.required]);
          ctrl?.updateValueAndValidity();
        });
        companyCtrl?.clearValidators();
        companyCtrl?.updateValueAndValidity();
      } else {
        companyCtrl?.setValidators([Validators.required]);
        companyCtrl?.updateValueAndValidity();
        personControls.forEach(ctrl => {
          ctrl?.clearValidators();
          ctrl?.updateValueAndValidity();
        });
      }
    } else {
      this.showInput = '';
      idCtrl?.setValidators([Validators.required]);
      idCtrl?.updateValueAndValidity();

      legacyControls.forEach(c => {
        const control = this.searchPersonForm.get(c);
        control?.clearValidators();
        control?.updateValueAndValidity();
      });
    }

    this.searchPersonForm.updateValueAndValidity();
  }

  clearDynamicControls() {
    const fixedControls = ['idNumber', 'selectIdSubDomain', 'name', 'secondName', 'surname', 'secondSurname', 'companyName'];

    Object.keys(this.searchPersonForm.controls).forEach(key => {
      if (!fixedControls.includes(key)) {
        this.searchPersonForm.removeControl(key);
      }
    });
  }

  forceUpperCase(controlName: string, event?: any) {
    const eventValue = event?.target?.value ?? event?.value;
    this.syncDynamicValue(controlName, eventValue);
  }

  syncDynamicValue(controlName: string, value: any): void {
    const control = this.searchPersonForm.get(controlName);
    if (!control) {
      return;
    }

    control.setValue(String(value ?? '').toUpperCase(), { emitEvent: false });
    control.updateValueAndValidity({ emitEvent: true });
    this.searchPersonForm.updateValueAndValidity({ emitEvent: true });
  }

  onSubmit(): void {
    this.resultsTable = null;

    this.showResultTable = false;
    this.showSinResultado = false;

    // Limpiar names del buscador previo antes de una nueva busqueda para evitar datos stale en el keying
    this.localStorageService.setKeyingNamesData = null;

    if (!(this.showInput === 'consumer' || this.showInput === 'commercial') && !this.searchPersonForm.valid) {
      this.resetMensajes();
    }

    const { selectIdSubDomain } = this.searchPersonForm.value;
    const country = this.regionSeleccionada.getCode();
    if (Number(selectIdSubDomain) === 0) {
      let idNumber: string = this.resultInput.toUpperCase().trim(); // .replace(/-/g, "");

      const observables = this.configSearchData.map(searchData => {
        if (country === "cl") {
          const subDomain = ['SRCEI_VERIFICATION', 'BUSINESS_LINE'];
          if (subDomain.includes(searchData.subDomain)) {
            const idNumberCero = idNumber.padStart(10, '0');
            idNumber = idNumberCero;
          }
        }
        if (country === 'pe') {
          if (searchData.profile === "COMMERCIAL" || searchData.profile === "CONSUMER") {
            idNumber = idNumber.padStart(12, '0')
          }
        }
        if (searchData.searchSourceType === 'PURPOSING') {
          return this.buscadorService.getKlPurposingData(idNumber, searchData).pipe(
            map((resp: any) => {
              if (!resp || !searchData?.purposingProfile) {
                return [];
              }
              const payload = resp?.payload ?? resp;
              return this.extractPurposingRows(payload, searchData.tableConfig || [], searchData.purposingProfile)
                .map((row: any) => ({
                  ...row,
                  type: searchData.purposingProfile || searchData.subDomain,
                  typeFormat: searchData.labelDropDown
                }));
            }),
            catchError(() => of([]))
          );
        }

        return this.buscadorService.searchDataAll(idNumber, searchData).pipe(
          map((type: any) => {
            const payload = type?.payload || {};
            const key = Object.keys(payload)[0] || searchData.subDomain;
            const rows = Array.isArray(payload[key]) ? payload[key] : [];

            return rows.map((x: any) => ({
              ...x,
              type: key,
              typeFormat: searchData.labelDropDown,
            }));
          }),
          catchError(() => of([]))
        );
      })
      forkJoin(observables).pipe(
        takeUntil(this.destroy$)
      ).subscribe({
        next: (response: any[]) => {
          this.typeAllProfile = true;
          const data = response.filter((rows) => Array.isArray(rows) && rows.length > 0);
          const uniqueArray = data.filter((item, index, self) =>
            index === self.findIndex(obj => JSON.stringify(obj) === JSON.stringify(item))
          )
          const objetoCombinado = uniqueArray.flatMap(x => x);
          if (objetoCombinado?.length === 0) {
            this.localStorageService.setPersonaSelectedDni = idNumber;
            if (!this.localStorageService.getIsVip) {
              this.notificationService.showError('No se encontraron resultados, intente nuevamente');
            }
          } else if (objetoCombinado?.length > 0) {
            this.localStorageService.setPersonaSelectedDni = idNumber;
            this.localStorageService.esAltaEntidades = false;
            let allTablet = [];
            objetoCombinado.forEach(element => {
              let typeSearh = this.configSearchData.find(config =>
                config.subDomain === element.type || config.purposingProfile === element.type
              );
              if (!typeSearh) {
                return;
              }
              const { subDomain, domain, tableConfig } = typeSearh;
              const newRow = tableConfig;
              let typePerOrEmp = this.handleProfileService.countrySelected.getUrlFindFull().find((profile) => (profile.subDomain === subDomain && profile.domain === domain))?.type || 'person';
              let countryCode = this.localStorageService.getRegionSeleccionada.getCode().toUpperCase();
              let countryObjSel = this.countries.find((elementCountry: Icountry) => elementCountry.code.toUpperCase() === countryCode);
              let countryObjSelUrlFind = countryObjSel?.url_find?.find((elementUrlFind: SearchCountry) =>
                elementUrlFind.domain === domain &&
                elementUrlFind.subDomain === subDomain
              );
              const fieldDni = countryObjSelUrlFind?.field_dni;
              let table = this.resultsTable = this.handleProfileService.handleObtenerPersonas([element], idNumber, typePerOrEmp, fieldDni);
              table.cols = newRow as any;
              allTablet.push(table);
            })

            const colTable = [{
              varLabel: "Tipo",
              varName: "typeFormat",
              order: "0",
              inputType: ''
            }];

            if (!this.localStorageService.getIsVip) {
              colTable.push({
                varLabel: "EntityKey",
                varName: "entityKey",
                order: "1",
                inputType: ''
              });
            }

            this.allTablet = this.generateTabletAll(allTablet);
            const cols = [...colTable, ...this.allTablet["cols"]];

            const uniqueRow3 = cols.filter((item, index, self) =>
              index === self.findIndex(
                (t) => t.varLabel === item.varLabel && t.varName === item.varName
              )
            );

            const tabletCols = uniqueRow3.map(config => new Col(config.varLabel, config.varName));
            this.allTablet["cols"] = tabletCols;
            this.resultsTable = this.allTablet as any;
            this.showResultTable = true;
          } else {

          }
        },
        error: (err) => {
          // ESTE BLOQUE ES CRUCIAL PARA EL DEBUG
          console.error('¡Ocurrió un error en el forkJoin!', err);

          // El objeto 'err' te dará pistas sobre cuál de las peticiones falló.
        },
        complete: () => {
          // Opcional: para saber cuándo se completa el proceso.
          // console.log('El forkJoin se ha completado.');
        }
      })
    } else if (this.showInput === 'advanced') {

      let idNumber: string = "";
      let finalValue: string = null;
      let namesData = {};
      if (this.hasAdvancedConfig) {
        this.profileSelected.configAvanced.forEach(field => {
          const key = field.name.toUpperCase();
          const control = this.searchPersonForm.get(key);
          let value = control?.value || "";

          if (value && typeof value === 'string') {
            value = value.toUpperCase();
          }
          namesData[key] = value;
        });
      }

      // Persistir los names del buscador (NAME_FULL, NAME_FIRST_NAME, etc.) para enriquecer el keying en ingestas
      this.localStorageService.setKeyingNamesData = namesData;

      let identifiersData = {};
      let valueInput = "";
      if (this.profileSelected?.identifiers) {
        this.profileSelected.identifiers.forEach((ident, i) => {
          const key = ident.name.toUpperCase();
          let currentValue: string = null;

          switch (ident.typeValue) {
            case 'input':
              if (ident.visible === true) {
                currentValue = this.searchPersonForm.get(key)?.value || "";
                valueInput = currentValue;
              } else {
                idNumber = ident.value || "";
                currentValue = ident.value || "";
              }
              break;
            case 'countryCode':
              currentValue = this.regionSeleccionada.getCode().toUpperCase();
              break;
            case 'countryName':
              currentValue = this.regionSeleccionada.getName() || "";
              break;
            default:
              currentValue = ident.value || "";
              break;
          }

          if (currentValue && typeof currentValue === 'string') {
            currentValue = currentValue.toUpperCase();
          }

          identifiersData[key] = currentValue;
          finalValue = currentValue;
        });
      }

      const profileSelected = this.configSearchData.find(config => config.id === selectIdSubDomain);
      if (profileSelected) {
        const { profile, domain, subDomain, profileBusqueda, tableConfig, entityKeyVisible, searchSourceType } = profileSelected;

        if (searchSourceType === 'PURPOSING') {
          const purposingEntityKey = String(valueInput || finalValue || this.resultInput || '').trim();
          this.localStorageService.setBuscadorSelect = profileSelected;
          this.executePurposingSearch(profileSelected, purposingEntityKey, purposingEntityKey);
          return;
        }

        this.buscadorService.getKlAdvance(namesData, identifiersData, profile, domain, subDomain, profileBusqueda)
          .pipe(takeUntil(this.destroy$))
          .subscribe({
            next: personasRes => {

              console.log('personasRes', personasRes);
              this.localStorageService.setBuscadorSelect = profileSelected;

              console.log('personasRes.payload', personasRes.payload);
              console.log('profileSelected', profileSelected);
              // payload puede ser array plano (algunos países) o un objeto con clave subDomain
              const personMap: any[] = personasRes.payload?.[subDomain]
                ?? (Array.isArray(personasRes.payload) ? personasRes.payload : []);

              console.log('personMap', personMap);
              const personFilter = personMap?.filter(person => Object.keys(person)?.length > 1);
              console.log('personFilter', personFilter);

              console.log('valueInput', valueInput);
              if (personFilter.length === 0) {
                this.localStorageService.setPersonaSelectedDni = valueInput;
                this.showSinResultado = true;
                if (!this.localStorageService.getIsVip && !this.profileSelected.addEntidad) {
                  this.notificationService.showError('No se encontraron resultados, intente nuevamente');
                }
              } else {
                let tabletSetCols: any = tableConfig;
                let tablet = this.handleProfileService.handleObtenerPersonas(personFilter, '');
                if (!this.localStorageService.getIsVip && entityKeyVisible) {
                  tabletSetCols = this.setEntityKeyToTable(tableConfig);
                }
                const tabletCols = tabletSetCols.map(config => new Col(config.varLabel, config.varName));
                tablet.cols = tabletCols;
                this.resultsTable = tablet;

                this.showResultTable = true;
              }
            }
          });
      }

    } else if (country === 'uy' && (selectIdSubDomain === '9' || selectIdSubDomain === '10')) {
      const valuesForm = this.searchPersonForm.value;
      const profileSelected = this.configSearchData.find(config => config.id === selectIdSubDomain);

      if (profileSelected) {
        const { profile, domain, subDomain, profileBusqueda, tableConfig } = profileSelected;
        this.buscadorService.getKlServiceUYName(valuesForm, profile, domain, subDomain, profileBusqueda)
          .pipe(takeUntil(this.destroy$))
          .subscribe({
            next: personasRes => {
              this.localStorageService.setBuscadorSelect = profileSelected;
              const personMap: any[] = personasRes.payload?.[subDomain] || [];
              const personFilter = personMap?.filter(person => Object.keys(person)?.length > 1);
              let tablet = this.handleProfileService.handleObtenerPersonas(personFilter, '');
              const tabletCols = tableConfig.map(config => new Col(config.varLabel, config.varName));
              tablet.cols = tabletCols;
              this.resultsTable = tablet;

              this.showResultTable = true;
            }
          });
      }

    } else if (this.resultInput && this.profileSelected?.tableConfig?.length > 0) {
      // this.showLoading();
      this.typeAllProfile = false;

      const rawInput: string = this.resultInput.trim();

      if (this.profileSelected?.searchSourceType === 'PURPOSING') {
        this.executePurposingSearch(this.profileSelected, rawInput, rawInput);
        return;
      }

      this.initTableConfigBuscador();

      let idNumber: string = rawInput.toUpperCase();

      if (country === "cl") {
        if (this.profileSelected.fieldDni === "rut") {
          const idNumberCero = idNumber.padStart(10, '0');
          idNumber = idNumberCero;
        }
      }
      if (country === 'pe') {
        if (this.profileSelected.profile === "COMMERCIAL" || this.profileSelected.profile === "CONSUMER") {
          idNumber = idNumber.padStart(12, '0');
        }
      }

      // Consulta servicio buscador
      this.buscadorService.searchData(idNumber)
        .pipe(takeUntil(this.destroy$))
        .subscribe({
          next: personasRes => {
            if (this.localStorageService.getIsVip && personasRes.payload?.length > 1 && country !== 'py') { // REVISAR PARA VIP
              this.showModalVip();
            } else {
              let keyFuenteXX = Object.keys(personasRes.payload)[0];
              const personMap: any[] = keyFuenteXX === this.profileSelected.subDomain ? personasRes.payload[keyFuenteXX] : personasRes.payload;
              const personFilter = personMap?.filter(person => Object.keys(person)?.length > 1);

              this.showTableData(personFilter, idNumber);
            }
          },
          error: _error => {
            console.error(_error);
          }
        });

    } else if (this.profileSelected && this.profileSelected.tableConfig.length == 0) { // AbmBuscador - Cuando la tabla del subDominio viene sin configuracion
      this.showModalTableNoConfig();
    }
  }

  initTableConfigBuscador() {
    if (!this.profileSelected || !this.profileSelected.tableConfig || this.profileSelected.tableConfig.length === 0) {
      return;
    }
    if (!this.profileSelected.entityKeyVisible) {
      this.profileSelected.tableConfig = this.profileSelected.tableConfig.filter(config => config.varName !== 'entityKey');
    }
    if (this.profileSelected.entityKeyVisible && this.profileSelected.tableConfig[0].varLabel !== 'EntityKey' && !this.localStorageService.getIsVip) {
      this.profileSelected.tableConfig.unshift({
        varLabel: "EntityKey",
        varName: "entityKey",
        order: "0",
        inputType: ''
      });
    }
    this.profileSelected.tableConfig.sort((a, b) => (parseInt(a?.order) > parseInt(b?.order) ? 1 : -1));
    this.localStorageService.getRegionSeleccionada.setTableConfig(
      this.profileSelected.tableConfig.map(
        config => {
          return new Col(config.varLabel, config.varName);
        }
      )
    );

    if (this.profileSelected.searchSourceType !== 'PURPOSING') {
      this.profileSelected.fieldDni = this.getFieldDni();
    }
    this.localStorageService.setBuscadorSelect = this.profileSelected;
  }

  // get FieldDni From identifiers config (advanced) or COUNTRIES.json (legacy)
  getFieldDni() {
    if (!this.profileSelected) {
      return undefined;
    }
    // For configs with identifiers, the visible input field is the document identifier
    if (this.profileSelected.identifiers?.length > 0) {
      const visibleInput = (this.profileSelected.identifiers as any[]).find(
        (ident) => ident.visible === true && ident.typeValue === 'input'
      );
      if (visibleInput?.name) {
        return visibleInput.name;
      }
    }
    // Legacy fallback: read from COUNTRIES.json via url_find
    let countryCode = this.localStorageService.getRegionSeleccionada.getCode().toUpperCase();
    let countryObjSel = this.countries.find((elementCountry: Icountry) => elementCountry.code?.toUpperCase() === countryCode);
    let countryObjSelUrlFind = countryObjSel?.url_find?.find((elementUrlFind: SearchCountry) =>
      elementUrlFind.domain === this.profileSelected.domain &&
      elementUrlFind.subDomain === this.profileSelected.subDomain
    );
    return countryObjSelUrlFind?.field_dni;
  }

  altaEntidades() {
    if (!this.profileSelected) {
      this.notificationService.showError('No se encontró la configuración de la fuente');
      return;
    }
    const { domain, subDomain } = this.profileSelected;
    const menuSelect: Menu = this.localStorageService.dataMenu.find(menu => menu.domainJO == domain && menu.subDomainJO == subDomain);

    if (!menuSelect) {
      console.error('[altaEntidades] No se encontró el menú para el dominio/subdominio');
      this.notificationService.showError('No se pudo encontrar la configuración de la fuente');
      return;
    }

    this.currentMenuForNewEntity = menuSelect;
    this.checkAvailableConfigsForNewEntity(menuSelect);
  }

  /**
   * Verifica las configuraciones disponibles antes de crear nueva entidad
   */
  checkAvailableConfigsForNewEntity(menuSelect: Menu) {
    this.loadingConfigs = true;
    const domain = menuSelect.domainJO;
    const subdomain = menuSelect.subDomainJO;

    console.log('[checkAvailableConfigsForNewEntity] Verificando fuente GFD:', { domain, subdomain });

    // Flujo para GFD
    this.gfdService.getGfdConfigs(domain, subdomain)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (response: any) => {
          console.log('[checkAvailableConfigsForNewEntity] Respuesta GFD configs:', response);

          // El backend puede devolver un array directamente o un objeto con propiedad configs
          let configs = [];

          if (Array.isArray(response)) {
            // Respuesta es un array directo
            configs = response;
          } else if (response?.configs && Array.isArray(response.configs)) {
            // Respuesta es un objeto con propiedad configs
            configs = response.configs;
          }

          if (configs.length > 0) {
            // Normalizar el formato: { name, description }
            this.availableConfigs = configs.map((config: any) => ({
              name: config.configName || config.name || config,
              description: config.comentarios || config.description || 'Sin descripción'
            }));

            console.log('[checkAvailableConfigsForNewEntity] Configs disponibles:', this.availableConfigs);

            if (this.availableConfigs.length === 1) {
              // Solo una configuración: entrar directamente
              console.log('[checkAvailableConfigsForNewEntity] Una sola config, entrando directamente');
              this.proceedWithNewEntity(this.availableConfigs[0].name);
            } else {
              // Múltiples configuraciones: abrir modal
              console.log('[checkAvailableConfigsForNewEntity] Múltiples configs, abriendo modal');
              this.openConfigModalForNewEntity();
            }
          } else {
            // Sin configuraciones: entrar sin config específica
            console.log('[checkAvailableConfigsForNewEntity] Sin configs, entrando directamente');
            this.proceedWithNewEntity(null);
          }
          this.loadingConfigs = false;
        },
        error: (error) => {
          console.error('[checkAvailableConfigsForNewEntity] Error al obtener configs:', error);
          // En caso de error, continuar sin config específica
          this.proceedWithNewEntity(null);
          this.loadingConfigs = false;
        }
      });
  }

  /**
   * Abre el modal de selección de configuraciones
   */
  openConfigModalForNewEntity() {
    console.log('[openConfigModalForNewEntity] Abriendo modal de configuraciones');
    console.log('[openConfigModalForNewEntity] availableConfigs:', this.availableConfigs);

    if (!this.availableConfigs || this.availableConfigs.length === 0) {
      console.warn('[openConfigModalForNewEntity] No hay configuraciones disponibles');
      this.notificationService.showInfo('No hay configuraciones disponibles');
      return;
    }

    this.showConfigModal = true;
  }

  /**
   * Cierra el modal de selección de configuraciones
   */
  closeConfigModal() {
    console.log('[closeConfigModal] Cerrando modal');
    this.showConfigModal = false;
  }

  /**
   * Maneja la selección de configuración desde el modal
   */
  onModalConfigSelected(config: any) {
    console.log('[onModalConfigSelected] Configuración seleccionada desde modal:', config);

    const configName = config.name || config;
    this.proceedWithNewEntity(configName);
    this.closeConfigModal();
  }

  /**
   * Procede con la creación de nueva entidad con la configuración seleccionada
   */
  proceedWithNewEntity(configName: string | null) {
    console.log('[proceedWithNewEntity] Procediendo con config:', configName);

    // Resetear keying para nueva entidad (sin keying previo)
    console.log('[KEYING] Creando nueva entidad - Reseteando keyingGkl y keyingGklBackup a null');
    this.fuenteDinamicaService.keyingGkl = null;
    this.fuenteDinamicaService.keyingGklBackup = null;

    const numDocumento = this.localStorageService.getPersonaSelectedDni;
    const { domain, subDomain, isHash } = this.profileSelected;
    const stringUrlSource: string = `${domain.toLowerCase()}/${subDomain.toLowerCase()}`;
    const menuSelect = this.currentMenuForNewEntity;

    const bodyPersona: { [key: string]: string } = isHash
      ? { hash: this.localStorageService.getPersonaSelectedDniHash }
      : { documento: this.resultInput };
    bodyPersona[this.getFieldDni()] = numDocumento;

    const personaNueva: Persona = new Persona(new Documento().deserialize({ numero: this.resultInput })).deserialize(bodyPersona);

    // Guardar documento en localStorage como fallback para el keying
    this.localStorageService.setAltaEntidadDocumento = this.resultInput;
    this.localStorageService.setDataSourceSelected = menuSelect;
    this.localStorageService.esAltaEntidades = true;
    this.localStorageService.esInternoRDS = false;

    // Guardar la configuración seleccionada si existe
    if (configName) {
      const isRdsSource = menuSelect.domainJO && (menuSelect.domainJO.toUpperCase().startsWith('RDS_') || menuSelect.domainJO.toUpperCase() === 'RDS');
      if (isRdsSource) {
        this.localStorageService.setSelectedRdsConfig = configName;
      } else {
        this.localStorageService.setSelectedGfdConfig = configName;
      }
      console.log('[proceedWithNewEntity] Configuración guardada:', configName);
    }

    this.goToNextPage(personaNueva, stringUrlSource);
  }

  showModalVip() {
    let countryObjSel = this.countries.find((elementCountry: Icountry) =>
      elementCountry.code.toUpperCase() === this.localStorageService.getCountryString
    );
    this.showModal = true;
    this.showimgModal = true;
    this.tituloModal = 'Problemas con el N° Documento';
    this.bodyModal = `Hay un problema con este N° Documento.<br>
    Por favor envía tu requerimiento a <strong>{{'` + countryObjSel.mail_contacto + `'}}</strong> <br>
    Mientras persista el problema no podrá continuar con la operación.`;
  }

  showModalTableNoConfig() {
    this.showModal = true;
    this.showimgModal = true;
    this.tituloModal = 'Tabla no configurada';
    this.bodyModal = `Para hacer uso de este buscador<br>
    Por favor configure los parámetros de la tabla en <strong>Mantenedor - Buscador</strong>  <br>
    Mientras persista el problema no podrá continuar con la operación.`;
  }

  getAttributeName(persona: any, text: string): string {
    const pathValue = this.getValueByPath(persona, text);
    if (pathValue !== undefined && pathValue !== null) {
      if (Array.isArray(pathValue)) {
        return this.formatUniqueDisplayValues(pathValue);
      }

      if (typeof pathValue === 'object') {
        return JSON.stringify(pathValue);
      }

      return String(pathValue).replace(",", ", ");
    }

    const fallbackValue = this.sharedService.getAttributeName(persona, text);

    if (Array.isArray(fallbackValue)) {
      return this.formatUniqueDisplayValues(fallbackValue);
    }

    return String(fallbackValue || '').replace(",", ", ");
  }

  private formatUniqueDisplayValues(values: any[]): string {
    const flatValues = values
      .flatMap((value) => Array.isArray(value) ? value : [value])
      .filter((value) => value !== undefined && value !== null)
      .map((value) => String(value).trim())
      .filter((value) => value !== '');

    const seen = new Set<string>();
    const uniqueValues = flatValues.filter((value) => {
      const normalized = value.toLocaleLowerCase();
      if (seen.has(normalized)) {
        return false;
      }
      seen.add(normalized);
      return true;
    });

    return uniqueValues.join('\n');
  }

  goToNextPage(persona: Persona, initUrl = 'fuentes') {
    this.localStorageService.esInternoRDS = false;
    this.localStorageService.setPersonaSelected = persona;

    // Asignar el keying de la persona seleccionada
    const personaKeying = persona.keying || null;
    console.log('[KEYING] Cambio de persona detectado - Asignando keying de la persona:', personaKeying);
    this.fuenteDinamicaService.keyingGkl = personaKeying;
    this.fuenteDinamicaService.keyingGklBackup = personaKeying;

    const stringUrlSource = `/${this.localStorageService.getIsVip
      ? 'vip'
      : this.localStorageService.getIsExternoRDS
        ? 'rdsportal'
        : 'int'}/data-maintenance/`;
    const urlSource = stringUrlSource + this.regionSeleccionada.getCode();
    // console.log("urlSource ----->", urlSource);
    const bolabCase = !this.localStorageService.getIsVip &&
      this.localStorageService.getRegionSeleccionada.getCode() === 'cl' &&
      this.localStorageService.getPermissionCountry.roles.toUpperCase() === this.sharedService.parseRolesArray(this.localStorageService.configInit['F_PERMISSION_ALL_ROLES'])[3]; // 'BOLAB'
    const getFirstSource = bolabCase ? 'cl_credit/delinquency_bolab' : initUrl;

    if (this.typeAllProfile === true) {
      let buscadorSelect = this.configSearchData.find(config => config.subDomain === persona["type"]);
      this.setTableConfig(buscadorSelect);
    }

    if (this.showInput !== '') {
      let buscadorSelect = this.localStorageService.getBuscadorSelect;
      this.setTableConfig(buscadorSelect);
    }

    this.router.navigateByUrl(urlSource + '/' + getFirstSource);
  }
  /**
   * Consume el servicio Menú y lo persiste en LocalStorageService.dataMenu
   */
  setMenuStorage() {
    const currentCountry = this.regionSeleccionada.getCode();
    let countryUpper = (currentCountry !== null) ? currentCountry.toUpperCase() : currentCountry;

    // console.log('countryUpper', countryUpper);
    // console.log('%c ' + this.componentName + " , " + ' setMenuStorage(' + currentCountry + ')', 'background: orange; color: black');

    // TODO revisar lógica de cuando se debe volver a cargar este consumo
    if (this.localStorageService.getIsVip) {
      setTimeout(() => {
        this.getMenu();
      }, 2000);
    } else {
      this.getMenu();
    }
  }

  getMenu() {
    // Solo limpiar el menú si está vacío o si venimos de RDS (para evitar limpiar un menú válido de Journalist)
    const currentMenuLength = this.localStorageService.dataMenu?.length || 0;
    const wasRds = this.localStorageService.esInternoRDS || this.localStorageService.getIsExternoRDS;

    if (currentMenuLength === 0 || wasRds) {
      this.localStorageService.setDataMenu = [];
      console.log('[HomeSearcher.getMenu] Menú limpiado antes de cargar nuevo menú (previo:', currentMenuLength, 'items, wasRds:', wasRds, ')');
    } else {
      console.log('[HomeSearcher.getMenu] Menú ya cargado con', currentMenuLength, 'items, no se limpia');
    }

    this.menuService.getMenu()
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (listMenu: any[]) => {
          // console.log('listMenu3', listMenu);
          this.localStorageService.setDataMenu = listMenu['items'].map(el => new Menu().deserialize(el));
          console.log('[HomeSearcher.getMenu] Nuevo menú cargado:', this.localStorageService.dataMenu.length, 'items');
        }
      );
  }

  setOption(configSearchData) {
    return configSearchData.map((config: any) => {
      return {
        key: config.id,
        name: config.labelDropDown,
        disabled: false
      }
    });
  }

  generateTabletAll(tablet) {
    return tablet.reduce((acc, current) => {
      acc.cols = acc.cols.concat(current.cols);
      acc.rows = acc.rows.concat(current.rows);
      return acc;
    })
  }

  addUYNameConfig() {
    const countryUY: Array<any> = [{
      "order": "9",
      "domain": "UY_CONSUMER_IDENTITY",
      "subDomain": "NATURAL_PERSON",
      "addEntidad": true,
      "labelDropDown": "Por Nombre - Persona",
      "identifyType": "9",
      "id": "9",
      "isHash": false,
      "tableConfig": [
        {
          "order": "1",
          "varName": "birth_date",
          "varLabel": "Fecha nacimiento"
        },
        {
          "order": "2",
          "varName": "desc_gender",
          "varLabel": "Descripcion sexo"
        },
        {
          "order": "3",
          "varName": "document_id",
          "varLabel": "Numero documento"
        },
        {
          "order": "4",
          "varName": "entity_document",
          "varLabel": "Documento entidad"
        },
        {
          "order": "5",
          "varName": "names",
          "varLabel": "Nombres"
        },
        {
          "order": "6",
          "varName": "surnames",
          "varLabel": "Apellidos"
        }
      ],
      "profile": "CONSUMER",
      "profileBusqueda": "dfkl_uy_profile_assignment_consumer_names",
      "typeNumber": "",
      "isDissociate": false
    }, {
      "order": "10",
      "domain": "UY_COMMERCIAL_IDENTITY",
      "subDomain": "LEGAL_ENTITY",
      "addEntidad": true,
      "labelDropDown": "Por Nompre - Empresa",
      "identifyType": "10",
      "id": "10",
      "isHash": false,
      "tableConfig": [
        {
          "order": "1",
          "varName": "company_fantasy_name",
          "varLabel": "Nombre fantasía"
        },
        {
          "order": "2",
          "varName": "company_legal_name",
          "varLabel": "Razón social"
        },
        {
          "order": "3",
          "varName": "document_id",
          "varLabel": "Número documento"
        }
      ],
      "profile": "COMMERCIAL",
      "profileBusqueda": "dfkl_uy_profile_assignment_commercial_business_name",
      "typeNumber": "",
      "isDissociate": false
    },]
    return countryUY;
  }

  showTableData(personFilter, idNumber) {
    // Sin Resultados
    if (personFilter?.length === 0) {
      this.localStorageService.setPersonaSelectedDni = idNumber;
      this.showSinResultado = true;
      if (!this.localStorageService.getIsVip && !this.profileSelected?.addEntidad) {
        this.notificationService.showError('No se encontraron resultados, intente nuevamente');
      }
    } else if (personFilter?.length > 0) { // Flujo con datos
      this.localStorageService.setPersonaSelectedDni = idNumber;
      this.localStorageService.esAltaEntidades = false;
      this.resultsTable = this.handleProfileService.handleObtenerPersonas(personFilter, idNumber);
      // Se limpia aquí para evitar mostrar documentos de una búsqueda previa.
      // El fetch de /documents ahora se realiza en Nominativo para la persona seleccionada.
      this.localStorageService.documentList = "";
      this.showResultTable = true;
    } else { // Documento null | undefined
      this.notificationService.showError('Problemas con el documento');
    }
  }

  private executePurposingSearch(
    buscadorConfig: IAbmBuscador,
    idNumber: string,
    entityKeyInput: string
  ): void {
    // Mantener el buscador seleccionado para flujos posteriores (fuente dinámica, keying, etc.)
    this.localStorageService.setBuscadorSelect = buscadorConfig;

    this.buscadorService.getKlPurposingData(entityKeyInput, buscadorConfig)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (response: any) => {
          this.showPurposingTableData(response, buscadorConfig, idNumber);
        },
        error: (err) => {
          console.error('Error al resolver entityKey para propósito:', err);
          this.notificationService.showError('No se pudo resolver el entityKey para la búsqueda de propósito.');
        }
      });
  }

  private showPurposingTableData(response: any, buscadorConfig: IAbmBuscador, idNumber: string): void {
    const payload = response?.payload ?? response;
    const rowsData = this.extractPurposingRows(payload, buscadorConfig?.tableConfig || [], buscadorConfig?.purposingProfile);

    if (!rowsData.length) {
      this.localStorageService.setPersonaSelectedDni = idNumber;
      this.showSinResultado = true;
      return;
    }

    this.setTableConfig(buscadorConfig);
    const tableCols = (buscadorConfig.tableConfig || []).map(config => new Col(config.varLabel, config.varName));
    this.resultsTable = { cols: tableCols, rows: rowsData.map((item) => ({ persona: item })) } as any;
    this.localStorageService.setPersonaSelectedDni = idNumber;
    this.showResultTable = true;
  }

  private extractPurposingRows(payload: any, tableConfig: any[], purposingProfile?: string): any[] {
    if (!payload) {
      return [];
    }

    const configuredFields = (tableConfig || []).map((c) => c?.varName).filter(Boolean);
    if (!configuredFields.length) {
      return [];
    }

    // Evita considerar filas "válidas" solo por tener entityKey.
    const businessFields = configuredFields.filter((field) => String(field).toLowerCase() !== 'entitykey');
    const validationFields = businessFields.length ? businessFields : configuredFields;

    const hasConfiguredValue = (row: any): boolean => {
      if (!row || typeof row !== 'object') {
        return false;
      }

      return validationFields.some((field) => {
        const value = this.getValueByPath(row, field);
        if (Array.isArray(value)) {
          return value.some((item) => item !== undefined && item !== null && String(item).trim() !== '');
        }
        return value !== undefined && value !== null && String(value).trim() !== '';
      });
    };

    const dedupeRows = (rows: any[]): any[] => {
      const seen = new Set<string>();
      return rows.filter((row) => {
        const key = configuredFields
          .map((field) => {
            const value = this.getValueByPath(row, field);
            if (Array.isArray(value)) {
              return JSON.stringify(value);
            }
            if (value && typeof value === 'object') {
              return JSON.stringify(value);
            }
            return String(value ?? '');
          })
          .join('||');
        if (seen.has(key)) {
          return false;
        }
        seen.add(key);
        return true;
      });
    };

    const candidates: any[] = [];

    if (Array.isArray(payload)) {
      candidates.push(...payload);
    } else if (typeof payload === 'object') {
      // Si la raíz ya contiene datos de negocio configurados, priorizarla.
      if (hasConfiguredValue(payload)) {
        return [payload];
      }

      candidates.push(payload);

      Object.keys(payload).forEach((key) => {
        if (Array.isArray(payload[key])) {
          candidates.push(...payload[key]);
        }
      });
    }

    if (purposingProfile && Array.isArray(payload[purposingProfile])) {
      candidates.push(...payload[purposingProfile]);
    }

    const filteredRows = candidates.filter(hasConfiguredValue);
    const uniqueRows = dedupeRows(filteredRows);

    // Fallback mínimo: si no hubo matches por columnas, intentar payload raíz
    if (!uniqueRows.length && typeof payload === 'object' && hasConfiguredValue(payload)) {
      return [payload];
    }

    return uniqueRows;
  }

  private safeParseJsonObject(value: any): Record<string, any> {
    if (value === undefined || value === null || value === '') {
      return {};
    }

    if (typeof value === 'object' && !Array.isArray(value)) {
      return value;
    }

    if (typeof value === 'string') {
      const trimmed = value.trim();
      if (!trimmed) {
        return {};
      }

      try {
        const parsed = JSON.parse(trimmed);
        return parsed && typeof parsed === 'object' && !Array.isArray(parsed) ? parsed : {};
      } catch {
        return {};
      }
    }

    return {};
  }

  private getValueByPath(source: any, path: string): any {
    if (!source || !path) {
      return undefined;
    }

    if (Object.prototype.hasOwnProperty.call(source, path)) {
      return source[path];
    }

    if (path.indexOf('.') === -1 && path.indexOf('[]') === -1) {
      return source[path];
    }

    const segments = path.split('.').filter(Boolean);
    let currentValues: any[] = [source];

    for (const segment of segments) {
      const isArraySegment = segment.endsWith('[]');
      const key = isArraySegment ? segment.slice(0, -2) : segment;
      const nextValues: any[] = [];

      currentValues.forEach((current) => {
        if (current === undefined || current === null) {
          return;
        }

        const value = key ? current[key] : current;
        if (value === undefined || value === null) {
          return;
        }

        if (isArraySegment) {
          if (Array.isArray(value)) {
            nextValues.push(...value);
          }
          return;
        }

        if (Array.isArray(value)) {
          nextValues.push(...value);
        } else {
          nextValues.push(value);
        }
      });

      currentValues = nextValues;
      if (!currentValues.length) {
        return undefined;
      }
    }

    if (currentValues.length === 1) {
      return currentValues[0];
    }

    return currentValues;
  }

  setTableConfig(buscadorSelect) {
    if (!buscadorSelect) {
      return;
    }
    const { domain, subDomain } = buscadorSelect;
    const countryCode = this.localStorageService.getRegionSeleccionada.getCode().toUpperCase();

    let countryObjSel = this.countries.find((elementCountry: Icountry) => elementCountry.code?.toUpperCase() === countryCode);

    let countryObjSelUrlFind = countryObjSel?.url_find?.find((elementUrlFind: SearchCountry) =>
      elementUrlFind.domain === domain &&
      elementUrlFind.subDomain === subDomain
    );

    if (!buscadorSelect.entityKeyVisible) {
      buscadorSelect.tableConfig = buscadorSelect.tableConfig.filter(config => config.varName !== 'entityKey');
    }
    if (buscadorSelect.entityKeyVisible && buscadorSelect.tableConfig[0].varLabel !== 'EntityKey') {
      buscadorSelect.tableConfig.unshift({
        varLabel: "EntityKey",
        varName: "entityKey",
        order: "0",
        inputType: ''
      });
    }

    this.localStorageService.getRegionSeleccionada.setTableConfig(
      buscadorSelect.tableConfig.map(
        config => {
          return new Col(config.varLabel, config.varName);
        }
      )
    );

    // Derive fieldDni from identifiers when available; fall back to COUNTRIES.json
    if (buscadorSelect.identifiers?.length > 0) {
      const visibleInput = (buscadorSelect.identifiers as any[]).find(
        (ident) => ident.visible === true && ident.typeValue === 'input'
      );
      buscadorSelect.fieldDni = visibleInput?.name ?? countryObjSelUrlFind?.field_dni;
    } else {
      buscadorSelect.fieldDni = countryObjSelUrlFind?.field_dni;
    }

    this.localStorageService.setBuscadorSelect = buscadorSelect;
  }

  setEntityKeyToTable(tableConfig) {
    if (tableConfig[0].varLabel !== 'EntityKey') {
      tableConfig.unshift({
        varLabel: "EntityKey",
        varName: "entityKey",
        order: "0",
        inputType: ''
      });
    }
    return tableConfig;
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

}
